
// shader that uses gaussian blur to draw a blurred version of the image.
export const fragment = `
precision highp float;

uniform vec2 resolution;
uniform sampler2D texture;

#define KERNEL_SIZE 16
#define KERNEL_SIZEF 16.0

float gaussian(vec2 d, float s) {
    return exp(-(d.x * d.x + d.y * d.y) / (2.0 * s * s));
}

vec4 gaussian_blur(vec2 uv, vec2 offset) {

    vec4 color = vec4(0.0);
    float weight = 0.0;

    const float k = 0.15915494;
    vec2 xy = vec2(0.0);
    for (int j = 0; j < KERNEL_SIZE; j++) {
        xy.y = -0.5 * (KERNEL_SIZEF - 1.0) + float(j);
        for (int i = 0; i < KERNEL_SIZE; i++) {
            xy.x = -0.5 * (KERNEL_SIZEF - 1.0) + float(i);
            float gaussian_weight = (k / KERNEL_SIZEF) * gaussian(xy, KERNEL_SIZEF);
            color += gaussian_weight * texture2D(texture, uv + xy * offset);
            weight += gaussian_weight;
        }
    }

    return color / weight;
}

varying vec2 v_uv;

void main() {
    vec2 pixel = 1.0 / resolution;
    gl_FragColor = gaussian_blur(v_uv, pixel);
}
`;